import { render, staticRenderFns } from "./AccountSelector.vue?vue&type=template&id=3a20bafa&scoped=true&"
import script from "./AccountSelector.vue?vue&type=script&lang=js&"
export * from "./AccountSelector.vue?vue&type=script&lang=js&"
import style0 from "./AccountSelector.vue?vue&type=style&index=0&id=3a20bafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20bafa",
  null
  
)

export default component.exports